<section id="section-spacing" class="container m-t-40">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Spacings</p>

    <div class="row m-t-20">
      <div class="col-12">
        <p class="m-0">
          All spacing (margins / paddings) must be multiples of 4, with 4px being the smallest possible spacing and 80px being the largest.
        </p>

        <p>
          Classes follow the pattern: .<strong>#attribute</strong>-<strong>#direction</strong>-<strong>#breakpoint</strong>-<strong
            >#size</strong
          >
          <br />
        </p>

        <p>
          <strong>Ex.:</strong>
        </p>

        <table>
          <tr>
            <td style="width: 100px">.m-t-12</td>
            <td>margin top: 12px</td>
          </tr>
          <tr>
            <td style="width: 100px">.p-l-12</td>
            <td>padding left: 12px</td>
          </tr>
          <tr>
            <td style="width: 100px">.m-tb-12</td>
            <td>margin top and bottom: 12px</td>
          </tr>
          <tr>
            <td style="width: 100px">.m-lr-12</td>
            <td>margin left and right: 12px</td>
          </tr>
          <tr>
            <td style="width: 100px">.m-t-sm-12</td>
            <td>margin top: 12px for devices <= "small"</td>
          </tr>
          <tr>
            <td style="width: 100px">.m-t-xs-12</td>
            <td>margin top: 12px for devices <= "extra-small"</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</section>
